import { Application, Controller } from "@hotwired/stimulus";

class CancelPurchaseContractsController extends Controller {
  static targets = ["numberField", "currentUnit", "currentAmount", "remainingUnit", "remainingAmount"];

  connect() {
    this.showAmount();
  }

  showAmount() {
    const cancelUnits = this.numberFieldTarget.value;
    const unitPrice = this.remainingAmountTarget.getAttribute('data-unit-price')
    const currentUnits = this.currentUnitTarget.getAttribute('data-current-unit');
    const currentAmount = this.currentAmountTarget.getAttribute('data-current-amount');
    const remainingUnitTag = this.remainingUnitTarget;
    const remainingAmountTag = this.remainingAmountTarget;

    remainingUnitTag.textContent = (currentUnits - cancelUnits) + '枚';
    remainingAmountTag.textContent = (currentAmount - this.remainingAmount(cancelUnits, unitPrice)).toLocaleString() + '円';
  }

  remainingAmount(units, unitPrice) {
    return Number(units) * Number(unitPrice);
  }


}

// Registered in admin.js
export { CancelPurchaseContractsController };
